export enum EPeriod {
  P1D = 'P1D',
  P7D = 'P7D',
  P1M = 'P1M',
  P3M = 'P3M',
  P4M = 'P4M',
  P6M = 'P6M',
  P1Y = 'P1Y',
  P2Y = 'P2Y',
}
